import request from '@/api/axios'
import { MessagePlugin } from 'tdesign-vue-next'

export function appAccess(alias) {
  //按上架状态分类查询应用列表
  return request({
    url: `/admin/app/access/alias/${alias}`,
    method: 'get',
  })
}
const routeAuth = async (alias) => {
  return new Promise((resolve, reject) => {
    appAccess(alias)
      .then((res) => {
        const { userIsGod, result, memberStatus, userStatus } = res?.data?.data || {}
        const hasAuth = userIsGod || (result === 'access' && memberStatus === 0 && userStatus === 0)
        hasAuth ? resolve(true) : resolve(false)
      })
      .catch((err) => {
        reject(false) //禁用
      })
  })
}
/**
 * 应用权限与跳转
 * hint 是否需要提示，默认是
 */
const appAliasEvent = async (applyName, hint = true) => {
  let applyUrl = null
  let errorMsg = null
  if (applyName) {
    try {
      const res = await appAccess(applyName)
      const { data, code } = res.data
      if (code === 0) {
        const { result, userStatus, memberStatus, app } = data
        const state = result === 'access' && userStatus === 0 && memberStatus === 0
        if (state) {
          const { url } = app
          const { protocol } = window.location
          // 判断url 里是否包含https和http
          applyUrl = url.includes('http') ? url : `${protocol}${url}`
        } else {
          errorMsg = '您暂无访问权限'
        }
      }
    } catch (error) {
      errorMsg = error.message || '请求失败'
    }
  }
  if (errorMsg && hint) MessagePlugin.error(errorMsg)
  return applyUrl
}
/**
 * 应用信息获取
 */
const appAliasInfo = (applyName) => {
  return new Promise((resolve, reject) => {
    appAccess(applyName)
      .then((res) => {
        const { userIsGod, result, memberStatus, userStatus, auth, menus } = res?.data?.data || {}
        const hasAuth = userIsGod || (result === 'access' && memberStatus === 0 && userStatus === 0)
        resolve({
          hasAuth,
          auth,
          menus,
        })
      })
      .catch((err) => {
        reject('请求失败')
      })
  })
}
export { routeAuth, appAliasEvent, appAliasInfo }
